export function getApiBaseUrl() {
  const hostname = window.location.hostname;
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

  return isLocal ? "http://localhost:3004/api" : "/api";
}

export async function readApiJson(response) {
  const text = await response.text();

  if (!text) {
    return {};
  }

  try {
    return JSON.parse(text);
  } catch {
    throw new Error(
      "Сервер вернул некорректный ответ. Проверьте, что API доступен.",
    );
  }
}
